import { useCallback } from "react";
import { GUEST_LANGUAGES } from "@/lib/constants";
import { useDocPack } from "@/lib/docpack";

// Afdrukken en formulieren kunnen in elke EU-taal; voor zeven talen staan de
// teksten hieronder handgeschreven, de rest wordt één keer vertaald en bewaard.
export const PRINT_LANGS = GUEST_LANGUAGES;

const D = {
  nl: {
    legend: "Legende", st_occupied: "Bezet", st_reserved: "Gereserveerd", st_ribbon: "Rood lintje", st_control: "Controle nodig",
    current: "Huidig",
    card_number: "Kaartnummer", valid_until: "Geldig tot",
    your_stay: "Uw verblijf",
    fill_hint: "Duidelijk en leesbaar invullen in blokletters a.u.b.", kind: "Aard / type", power_hint: "Aankruisen welke stroomvoorziening je wil.",
    free_title: "Vrije plaatsen in de periode",
    free_direct: "Zonder verhuis", free_one: "Met 1 verhuis", free_two: "Met 2 verhuizen", free_move_on: "verhuis op", until: "t/m",
    total: "Totaal",
    form_title: "Inschrijvingsformulier",
    copy_guest: "Inschrijvingsformulier", copy_camping: "Contract", scan_to_complete: "Scan om zelf aan te vullen",
    chosen_pitch: "Gekozen locatie",
    booker: "Hoofdboeker",
    first_name: "Voornaam", last_name: "Achternaam", birth: "Geboortedatum", street: "Straat", house: "Huisnummer",
    postal: "Postcode", city: "Woonplaats", country: "Land", passport: "Paspoortnummer", issue_country: "Land van uitgifte", issue_place: "Plaats van uitgifte",
    from: "Van", to: "Tot", qty: "Aantal", plate: "Nummerplaat",
    adults: "Volwassenen", children: "Kinderen (4 tot 12 j)", car: "Auto", caravan: "Caravan", mobilhome: "Mobilhome", trailer: "Aanhanger",
    tent: "Tent", moto: "Moto", boat: "Boot", mobilhome9: "Mobilhome > 9 m", dog: "Hond", power: "Stroomkeuze", bungalow: "Bungalow", cabin: "Hut",
    info: "Algemene informatie", phone: "Telefoon", mail: "E-mail", signature: "Handtekening", date: "Datum",
    price_estimate: "Prijsindicatie voor de gekozen periode", vat: "Btw", total_incl: "Totaal incl. btw", price_note: "Indicatie op basis van de huidige tarieven en de gekozen periode. Winkel, verhuur en extra's zijn niet inbegrepen. Onder voorbehoud van wijzigingen.",
  },
  es: {
    legend: "Leyenda", st_occupied: "Ocupado", st_reserved: "Reservado", st_ribbon: "Cinta roja", st_control: "Requiere control",
    current: "Actual",
    card_number: "Nº de tarjeta", valid_until: "Válida hasta",
    your_stay: "Su estancia",
    fill_hint: "Rellenar de forma clara y legible, en mayúsculas, por favor.", kind: "Tipo", power_hint: "Marque la potencia eléctrica que desea.",
    free_title: "Parcelas libres en el período",
    free_direct: "Sin cambio", free_one: "Con 1 cambio", free_two: "Con 2 cambios", free_move_on: "cambio el", until: "hasta",
    total: "Total",
    form_title: "Formulario de inscripción",
    copy_guest: "Formulario de inscripción", copy_camping: "Contrato", scan_to_complete: "Escanee para completar",
    chosen_pitch: "Ubicación elegida",
    booker: "Titular principal",
    first_name: "Nombre", last_name: "Apellidos", birth: "Fecha de nacimiento", street: "Calle", house: "Número",
    postal: "Código postal", city: "Localidad", country: "País", passport: "Nº de pasaporte", issue_country: "País de expedición", issue_place: "Lugar de expedición",
    from: "Desde", to: "Hasta", qty: "Cantidad", plate: "Matrícula",
    adults: "Adultos", children: "Niños (4 a 12 años)", car: "Coche", caravan: "Caravana", mobilhome: "Autocaravana", trailer: "Remolque",
    tent: "Tienda", moto: "Moto", boat: "Barco", mobilhome9: "Autocaravana > 9 m", dog: "Perro", power: "Electricidad", bungalow: "Bungalow", cabin: "Cabaña",
    info: "Información general", phone: "Teléfono", mail: "Correo", signature: "Firma", date: "Fecha",
    price_estimate: "Estimación de precio para el período elegido", vat: "IVA", total_incl: "Total con IVA", price_note: "Estimación según las tarifas actuales y el período elegido. No incluye tienda, alquiler ni extras. Sujeto a cambios.",
  },
  de: {
    legend: "Legende", st_occupied: "Belegt", st_reserved: "Reserviert", st_ribbon: "Rotes Band", st_control: "Kontrolle nötig",
    current: "Aktuell",
    card_number: "Kartennummer", valid_until: "Gültig bis",
    your_stay: "Ihr Aufenthalt",
    fill_hint: "Bitte deutlich und lesbar in Blockschrift ausfüllen.", kind: "Art / Typ", power_hint: "Bitte gewünschte Stromversorgung ankreuzen.",
    free_title: "Freie Plätze im Zeitraum",
    free_direct: "Ohne Umzug", free_one: "Mit 1 Umzug", free_two: "Mit 2 Umzügen", free_move_on: "Umzug am", until: "bis",
    total: "Gesamt",
    form_title: "Anmeldeformular",
    copy_guest: "Anmeldeformular", copy_camping: "Vertrag", scan_to_complete: "Zum Ausfüllen scannen",
    chosen_pitch: "Gewählter Platz",
    booker: "Hauptbucher",
    first_name: "Vorname", last_name: "Nachname", birth: "Geburtsdatum", street: "Straße", house: "Hausnummer",
    postal: "Postleitzahl", city: "Wohnort", country: "Land", passport: "Passnummer", issue_country: "Ausstellungsland", issue_place: "Ausstellungsort",
    from: "Von", to: "Bis", qty: "Anzahl", plate: "Kennzeichen",
    adults: "Erwachsene", children: "Kinder (4 bis 12 J.)", car: "Auto", caravan: "Wohnwagen", mobilhome: "Wohnmobil", trailer: "Anhänger",
    tent: "Zelt", moto: "Motorrad", boat: "Boot", mobilhome9: "Wohnmobil > 9 m", dog: "Hund", power: "Stromwahl", bungalow: "Bungalow", cabin: "Hütte",
    info: "Allgemeine Informationen", phone: "Telefon", mail: "E-Mail", signature: "Unterschrift", date: "Datum",
    price_estimate: "Preisangabe für den gewählten Zeitraum", vat: "MwSt.", total_incl: "Gesamt inkl. MwSt.", price_note: "Richtpreis auf Basis der aktuellen Tarife und des gewählten Zeitraums. Shop, Mietartikel und Extras sind nicht enthalten. Änderungen vorbehalten.",
  },
  en: {
    legend: "Legend", st_occupied: "Occupied", st_reserved: "Reserved", st_ribbon: "Red ribbon", st_control: "Check needed",
    current: "Current",
    card_number: "Card number", valid_until: "Valid until",
    your_stay: "Your stay",
    fill_hint: "Please fill in clearly and legibly in block letters.", kind: "Kind / type", power_hint: "Tick the electricity supply you want.",
    free_title: "Free pitches in the period",
    free_direct: "No move", free_one: "With 1 move", free_two: "With 2 moves", free_move_on: "move on", until: "until",
    total: "Total",
    form_title: "Registration form",
    copy_guest: "Registration form", copy_camping: "Contract", scan_to_complete: "Scan to complete online",
    chosen_pitch: "Chosen pitch",
    booker: "Main booker",
    first_name: "First name", last_name: "Last name", birth: "Date of birth", street: "Street", house: "House number",
    postal: "Postal code", city: "City", country: "Country", passport: "Passport number", issue_country: "Country of issue", issue_place: "Place of issue",
    from: "From", to: "To", qty: "Number", plate: "Licence plate",
    adults: "Adults", children: "Children (4 to 12 y)", car: "Car", caravan: "Caravan", mobilhome: "Motorhome", trailer: "Trailer",
    tent: "Tent", moto: "Motorbike", boat: "Boat", mobilhome9: "Motorhome > 9 m", dog: "Dog", power: "Electricity", bungalow: "Bungalow", cabin: "Cabin",
    info: "General information", phone: "Phone", mail: "E-mail", signature: "Signature", date: "Date",
    price_estimate: "Price estimate for the chosen period", vat: "VAT", total_incl: "Total incl. VAT", price_note: "Estimate based on the current rates and the chosen period. Shop, rentals and extras are not included. Subject to change.",
  },
  no: {
    legend: "Tegnforklaring", st_occupied: "Opptatt", st_reserved: "Reservert", st_ribbon: "Rødt bånd", st_control: "Kontroll nødvendig",
    current: "Nå",
    card_number: "Kortnummer", valid_until: "Gyldig til",
    your_stay: "Ditt opphold",
    fill_hint: "Vennligst fyll ut tydelig og lesbart med blokkbokstaver.", kind: "Type", power_hint: "Kryss av for ønsket strømforsyning.",
    free_title: "Ledige plasser i perioden",
    free_direct: "Uten flytting", free_one: "Med 1 flytting", free_two: "Med 2 flyttinger", free_move_on: "flytt", until: "til",
    total: "Totalt",
    form_title: "Registreringsskjema",
    copy_guest: "Registreringsskjema", copy_camping: "Kontrakt", scan_to_complete: "Skann for å fylle ut",
    chosen_pitch: "Valgt plass",
    booker: "Hovedbestiller",
    first_name: "Fornavn", last_name: "Etternavn", birth: "Fødselsdato", street: "Gate", house: "Husnummer",
    postal: "Postnummer", city: "Bosted", country: "Land", passport: "Passnummer", issue_country: "Utstedelsesland", issue_place: "Utstedelsessted",
    from: "Fra", to: "Til", qty: "Antall", plate: "Registreringsnummer",
    adults: "Voksne", children: "Barn (4 til 12 år)", car: "Bil", caravan: "Campingvogn", mobilhome: "Bobil", trailer: "Tilhenger",
    tent: "Telt", moto: "Motorsykkel", boat: "Båt", mobilhome9: "Bobil > 9 m", dog: "Hund", power: "Strømvalg", bungalow: "Bungalow", cabin: "Hytte",
    info: "Generell informasjon", phone: "Telefon", mail: "E-post", signature: "Signatur", date: "Dato",
    price_estimate: "Prisanslag for valgt periode", vat: "MVA", total_incl: "Totalt inkl. MVA", price_note: "Anslag basert på gjeldende priser og valgt periode. Butikk, utleie og ekstra er ikke inkludert. Med forbehold om endringer.",
  },
  da: {
    legend: "Forklaring", st_occupied: "Optaget", st_reserved: "Reserveret", st_ribbon: "Rødt bånd", st_control: "Kontrol nødvendig",
    current: "Nu",
    card_number: "Kortnummer", valid_until: "Gyldig til",
    your_stay: "Dit ophold",
    fill_hint: "Udfyld venligst tydeligt og læseligt med blokbogstaver.", kind: "Type", power_hint: "Sæt kryds ved den ønskede strømforsyning.",
    free_title: "Ledige pladser i perioden",
    free_direct: "Uden flytning", free_one: "Med 1 flytning", free_two: "Med 2 flytninger", free_move_on: "flyt", until: "til",
    total: "I alt",
    form_title: "Registreringsformular",
    copy_guest: "Registreringsformular", copy_camping: "Kontrakt", scan_to_complete: "Scan for at udfylde",
    chosen_pitch: "Valgt plads",
    booker: "Hovedbestiller",
    first_name: "Fornavn", last_name: "Efternavn", birth: "Fødselsdato", street: "Gade", house: "Husnummer",
    postal: "Postnummer", city: "By", country: "Land", passport: "Pasnummer", issue_country: "Udstedelsesland", issue_place: "Udstedelsessted",
    from: "Fra", to: "Til", qty: "Antal", plate: "Nummerplade",
    adults: "Voksne", children: "Børn (4 til 12 år)", car: "Bil", caravan: "Campingvogn", mobilhome: "Autocamper", trailer: "Trailer",
    tent: "Telt", moto: "Motorcykel", boat: "Båd", mobilhome9: "Autocamper > 9 m", dog: "Hund", power: "Strømvalg", bungalow: "Bungalow", cabin: "Hytte",
    info: "Generel information", phone: "Telefon", mail: "E-mail", signature: "Underskrift", date: "Dato",
    price_estimate: "Prisoverslag for den valgte periode", vat: "Moms", total_incl: "I alt inkl. moms", price_note: "Overslag baseret på de aktuelle priser og den valgte periode. Butik, udlejning og ekstra er ikke inkluderet. Ret til ændringer forbeholdes.",
  },
  fr: {
    legend: "Légende", st_occupied: "Occupé", st_reserved: "Réservé", st_ribbon: "Ruban rouge", st_control: "Contrôle nécessaire",
    current: "Actuel",
    card_number: "Numéro de carte", valid_until: "Valable jusqu'au",
    your_stay: "Votre séjour",
    fill_hint: "Veuillez remplir clairement et lisiblement en lettres majuscules.", kind: "Nature / type", power_hint: "Cochez l'alimentation électrique souhaitée.",
    free_title: "Emplacements libres pour la période",
    free_direct: "Sans déménagement", free_one: "Avec 1 déménagement", free_two: "Avec 2 déménagements", free_move_on: "déménagement le", until: "jusqu'au",
    total: "Total",
    form_title: "Formulaire d'inscription",
    copy_guest: "Formulaire d'inscription", copy_camping: "Contrat", scan_to_complete: "Scannez pour compléter",
    chosen_pitch: "Emplacement choisi",
    booker: "Réservataire principal",
    first_name: "Prénom", last_name: "Nom", birth: "Date de naissance", street: "Rue", house: "Numéro",
    postal: "Code postal", city: "Localité", country: "Pays", passport: "Numéro de passeport", issue_country: "Pays de délivrance", issue_place: "Lieu de délivrance",
    from: "Du", to: "Au", qty: "Nombre", plate: "Immatriculation",
    adults: "Adultes", children: "Enfants (4 à 12 ans)", car: "Voiture", caravan: "Caravane", mobilhome: "Camping-car", trailer: "Remorque",
    tent: "Tente", moto: "Moto", boat: "Bateau", mobilhome9: "Camping-car > 9 m", dog: "Chien", power: "Électricité", bungalow: "Bungalow", cabin: "Chalet",
    info: "Informations générales", phone: "Téléphone", mail: "E-mail", signature: "Signature", date: "Date",
    price_estimate: "Estimation du prix pour la période choisie", vat: "TVA", total_incl: "Total TVA comprise", price_note: "Estimation basée sur les tarifs actuels et la période choisie. Boutique, location et extras non inclus. Sous réserve de modifications.",
  },
};

export const pt = (lang) => (key) => D[lang]?.[key] ?? D.nl[key] ?? key;

/** Zelfde als pt(), maar vult talen zonder handgeschreven teksten aan met een
 *  AI-vertaling. Zolang die onderweg is, geldt de Nederlandse tekst. */
export function usePrintT(lang) {
  const extra = useDocPack("print_doc", lang, D.nl,
    "labels op een inschrijvingsformulier en een plattegrond-afdruk voor een campinggast");
  return useCallback((key) => extra?.[key] ?? D[lang]?.[key] ?? D.nl[key] ?? key, [extra, lang]);
}

export const CAMPING = {
  name: "Camping Cap-Blanch",
  street: "Carretera del Albir 25,",
  city: "Altea, 03590 (Alicante)",
  phone: "+34 965 845 946",
  gps: "38.57739 / 0.06451",
  mail: "info@camping-capblanch.com",
};

// rows: key, icon file (null = placeholder), plate field?
export const FORM_ROWS = [
  { key: "adults", icon: "adult" },
  { key: "children", icon: "child" },
  { key: "car", icon: "car", plate: true },
  { key: "caravan", icon: "caravan", plate: true },
  { key: "mobilhome", icon: "mobilhome", plate: true },
  { key: "trailer", icon: "trailer", plate: true },
  { key: "tent", icon: "tent" },
  { key: "moto", icon: "moto", plate: true },
  { key: "boat", icon: "boat" },
  { key: "mobilhome9", icon: "mobilhome9", plate: true },
  { key: "dog", icon: "dog" },
  { key: "power", icon: "amp", power: true },
  { key: "bungalow", icon: "bungalow" },
  { key: "cabin", icon: "cabin" },
];
